const COOKIE_NAME = 'expert_ref';
const COOKIE_DAYS = 30;

export function setExpertRefCookie(referralCode) {
  if (!referralCode || typeof document === 'undefined') return;
  const maxAge = COOKIE_DAYS * 86400;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(referralCode)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function getExpertRefCookie() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function getPersonaLabel(type) {
  const map = {
    trainer: 'Тренер',
    fitness_blogger: 'Фитнес-блогер',
    nutritionist: 'Нутрициолог',
    other: 'Эксперт'
  };
  return map[type] || 'Эксперт';
}

export const GOAL_LABELS = {
  mass_gain: 'Набор массы',
  wellness: 'Улучшение самочувствия',
  weight_loss: 'Снижение веса'
};
